import {
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { addressSelectionUI } from 'platform/shared/health-apps';
import content from '../../../locales/en/content.json';

const TITLE_TEXT = content['primary-address--selection-title'];
const DESC_TEXT = content['primary-address--selection-description'];
const INPUT_LABELS = {
  selection: content['primary-address--selection-label'],
  sameAs: content['primary-address--same-as-label'],
};

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    'view:primarySharedAddress': addressSelectionUI({
      title: INPUT_LABELS.selection,
      destinationKey: 'primaryAddress',
      sourceKeys: ['veteranAddress'],
    }),
    'view:primaryHomeSameAsMailingAddress': yesNoUI(INPUT_LABELS.sameAs),
  },
  schema: {
    type: 'object',
    required: [
      'view:primarySharedAddress',
      'view:primaryHomeSameAsMailingAddress',
    ],
    properties: {
      'view:primarySharedAddress': { type: 'string' },
      'view:primaryHomeSameAsMailingAddress': yesNoSchema,
    },
  },
};
